















import Vue from "vue";
import SubscribeForUpdatesDialog from "../Utilities/SubscribeForUpdatesDialog.vue";

export default Vue.extend({
  name: "SubscribeButton",
  data: () => ({
    modalVisible: false as boolean
  }),
  components: {
    SubscribeForUpdatesDialog
  },
  computed: {
    modalWidth(): string {
      return this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm
        ? "100%"
        : "50%";
    }
  },
  methods: {
    hideModal() {
      this.modalVisible = false;
    }
  }
});
